import { defineMessages } from "react-intl";

export const customerFormsMessages = defineMessages({
  sectionName: {
    id: "Uq0lUd",
    defaultMessage: "Customer forms",
    description: "sidebar group name",
  },
  tabNewsletter: {
    id: "LWosQf",
    defaultMessage: "Newsletter",
    description: "customer forms tab",
  },
  tabFeedback: {
    id: "3x2V24",
    defaultMessage: "Feedback",
    description: "customer forms tab",
  },
  tabProductAlerts: {
    id: "cfW3Mj",
    defaultMessage: "Product alerts",
    description: "customer forms tab",
  },
});
